import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable, combineLatest, BehaviorSubject, ReplaySubject } from 'rxjs';
import { PackageDetails } from './package';
import { map, take, tap, filter, shareReplay } from 'rxjs/operators';
import { StoreLineItem } from './interface';
import { LMI_CATEGORIES_BY_NAME } from '../lmi-categories';
import { AppPrice } from '@vendasta/marketplace-apps';

@Component({
  selector: 'store-package-details-v2',
  templateUrl: 'package-details-v2.component.html',
  styleUrls: ['./package-details-v2.component.scss'],
  standalone: false,
})
export class VaPackageDetailsV2Component {
  @Input() showActionButton = true;
  @Input() showPricing = true;
  @Input() actionLabel = 'FRONTEND.STORE.GET_IT_NOW';
  @Input() appPrice: AppPrice;
  @Input() set pkg(pkg: PackageDetails) {
    this.pkg$$.next(pkg);
    this.enableAddToCart = pkg.pricing.prices.length > 0;
  }
  @Input() hideTags = false;
  @Output() getItNow = new EventEmitter();

  @Output() contactActionClicked = new EventEmitter<null>();

  pkg$$ = new ReplaySubject<PackageDetails>(1);
  itemSelectedEvent$$ = new BehaviorSubject<string>('');
  selectedItem$: Observable<StoreLineItem>;
  orderedLineItems$: Observable<StoreLineItem[]>;
  productNameForSingleAddon$: Observable<string>;
  lmiCategories$: Observable<string[]>;
  enableAddToCart = true;

  constructor() {
    this.orderedLineItems$ = this.pkg$$.pipe(
      map((pkg) => pkg.line_items),
      filter((items) => !!items || items.length === 0),
      shareReplay(1),
    );

    this.productNameForSingleAddon$ = this.orderedLineItems$.pipe(map((items) => this.getParentsNameForItem(items)));

    this.selectedItem$ = combineLatest([this.itemSelectedEvent$$, this.orderedLineItems$]).pipe(
      map(([id, lineItems]) => lineItems.find((lineItem) => lineItem.item.id === id)),
    );

    this.lmiCategories$ = this.orderedLineItems$.pipe(
      map((lis) => {
        const lmiMap = (lis || []).reduce((prev, li) => {
          if (li && li.item) {
            (li.item.lmiCategories || []).forEach((lmi) => prev.set(lmi, lmi));
          }
          return prev;
        }, new Map<string, string>());

        const lmiCats = [];
        lmiMap.forEach((v, k) => {
          if (Object.prototype.hasOwnProperty.call(LMI_CATEGORIES_BY_NAME, k)) {
            lmiCats.push(LMI_CATEGORIES_BY_NAME[k].i18nKey);
          } else {
            lmiCats.push(k);
          }
        });
        return lmiCats;
      }),
    );

    // Set the initial selected Item
    this.orderedLineItems$
      .pipe(
        map((lineItems) => lineItems[0]),
        tap((lineItem) => this.selectItem(lineItem && lineItem.item ? lineItem.item.id : '')),
        take(1),
      )
      .subscribe();
  }

  selectItem(id: string): void {
    this.itemSelectedEvent$$.next(id);
  }

  emitGetItNow(): void {
    this.getItNow.emit();
  }

  getParentsNameForItem(items: StoreLineItem[]): string {
    if (items && items.length === 1 && items[0]) {
      return items[0].parent.name;
    }
  }

  handleContactActionClick() {
    this.contactActionClicked.emit();
  }
}
